<template>
  <img
    v-if="!useAsBackground"
    :src="imageSource"
    :alt="description"
    :width="width"
    :height="height">
  <div v-else>
    <img :src="imageSource" :alt="description">
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    useAsBackground: { type: Boolean, default: false },
    src: { type: String, required: true },
    description: { type: String, default: null },
    placeholder: { type: String, default: null },
    width: { type: String, default: null },
    height: { type: String, default: null }
  },
  computed: {
    imageSource() {
      const assetsPath = '@/assets'
      if(_.startsWith(this.src, assetsPath)) {
        return require('@/assets' + this.src.substr(assetsPath.length, this.src.length))
      }
      if(process.env.VUE_APP_TYPE === 'spa') {
        if(this.placeholder) {
          return `https://placeimg.com/${this.placeholder}`
        }
        return (process.env.VUE_APP_IMAGE_BASE_URL || '') + this.src
      }
      return this.src
    }
  }
}
</script>
